if (!customElements.get('courses-and-events-carousel')) {
  const DESKTOP_BREAKPOINT = 990;
  const SLIDES_PER_PAGE = 3;

  class CoursesAndEventsCarousel extends HTMLElement {
    constructor() {
      super();
      this.slider = this.querySelector('[data-carousel-slider]');
      this.slides = this.querySelectorAll('[data-carousel-slide]');
      this.mobileDots = this.querySelectorAll('[data-carousel-dot-mobile]');
      this.desktopDots = this.querySelectorAll('[data-carousel-dot-desktop]');
      this.currentIndex = 0;

      if (!this.slider || this.slides.length === 0) return;

      this.init();
    }

    init() {
      for (const dot of this.mobileDots) {
        const slideIndex = parseInt(dot.dataset.slideIndex, 10);
        dot.addEventListener('click', () => this.goToSlide(slideIndex));
      }

      for (const dot of this.desktopDots) {
        const targetSlide = parseInt(dot.dataset.targetSlide, 10);
        dot.addEventListener('click', () => this.goToSlide(targetSlide));
      }

      this.slider.addEventListener(
        'scroll',
        debounce(() => this.updateActiveDots(), 50)
      );

      this.updateActiveDots();

      this.addEventListener('keydown', this.handleKeyDown.bind(this));
    }

    isDesktop() {
      return window.innerWidth >= DESKTOP_BREAKPOINT;
    }

    goToSlide(index) {
      if (index < 0 || index >= this.slides.length) return;

      const slide = this.slides[index];
      if (!slide) return;

      let scrollPosition;

      if (this.isDesktop()) {
        scrollPosition = slide.offsetLeft;
      } else {
        const sliderWidth = this.slider.clientWidth;
        const slideWidth = slide.clientWidth;
        const slideCenter = slide.offsetLeft + slideWidth / 2;
        scrollPosition = slideCenter - sliderWidth / 2;
      }

      this.slider.scrollTo({
        left: scrollPosition,
        behavior: 'smooth',
      });

      this.currentIndex = index;
      this.updateActiveDots();
    }

    updateActiveDots() {
      const scrollLeft = this.slider.scrollLeft;
      const sliderWidth = this.slider.clientWidth;

      let closestIndex = 0;

      if (this.isDesktop()) {
        let slideIndex = 0;
        for (const slide of this.slides) {
          if (slide.offsetLeft >= scrollLeft - 10) {
            closestIndex = slideIndex;
            break;
          }
          slideIndex++;
        }
      } else {
        let closestDistance = Infinity;
        let slideIndex = 0;
        for (const slide of this.slides) {
          const slideCenter = slide.offsetLeft + slide.clientWidth / 2;
          const viewCenter = scrollLeft + sliderWidth / 2;
          const distance = Math.abs(slideCenter - viewCenter);

          if (distance < closestDistance) {
            closestDistance = distance;
            closestIndex = slideIndex;
          }
          slideIndex++;
        }
      }

      this.currentIndex = closestIndex;

      for (const dot of this.mobileDots) {
        const slideIndex = parseInt(dot.dataset.slideIndex, 10);
        dot.setAttribute('aria-current', slideIndex === closestIndex ? 'true' : 'false');
      }

      this.updateDesktopDots(closestIndex);
    }

    updateDesktopDots(firstVisibleSlide) {
      let closestDot = null;
      let closestDistance = Infinity;

      for (const dot of this.desktopDots) {
        const targetSlide = parseInt(dot.dataset.targetSlide, 10);
        const distance = Math.abs(firstVisibleSlide - targetSlide);

        if (distance < closestDistance) {
          closestDistance = distance;
          closestDot = dot;
        }
      }

      for (const dot of this.desktopDots) {
        dot.setAttribute('aria-current', dot === closestDot ? 'true' : 'false');
      }
    }

    handleKeyDown(event) {
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        if (this.isDesktop()) {
          const newIndex = Math.max(0, this.currentIndex - SLIDES_PER_PAGE);
          this.goToSlide(newIndex);
        } else {
          this.goToSlide(Math.max(0, this.currentIndex - 1));
        }
      } else if (event.key === 'ArrowRight') {
        event.preventDefault();
        if (this.isDesktop()) {
          const newIndex = Math.min(this.slides.length - 1, this.currentIndex + SLIDES_PER_PAGE);
          this.goToSlide(newIndex);
        } else {
          this.goToSlide(Math.min(this.slides.length - 1, this.currentIndex + 1));
        }
      }
    }
  }

  customElements.define('courses-and-events-carousel', CoursesAndEventsCarousel);
}
